import React from "react";
import PropTypes from "prop-types";
import { Stage, Layer } from "react-konva";
import { Typography, Box } from "@mui/material";
import LayerImage from "./LayerImage";

function ShirtViewerPreview({
  width,
  height,
  layers,
  title,
  stageRef,
  zoom,
  readOnly,
  hideBorder,
  hideTitle,
  topRightSlot,
}) {
  const safeLayers = Array.isArray(layers) ? layers : [];

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" height="100%" width={width}>
      {!hideTitle && (
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" mb={1}>
          <Typography fontWeight="bold" fontSize="16px" color="text.primary">
            {title}
          </Typography>
          {topRightSlot}
        </Box>
      )}

      <Box
        border={hideBorder ? "none" : "1px solid #ccc"}
        borderRadius="8px"
        padding="4px"
        width={width + 4}
        height={height + 10}
      >
        <Stage
          width={width}
          height={height}
          scale={{ x: zoom, y: zoom }}
          pixelRatio={2}
          imageSmoothingEnabled={!readOnly}
          ref={stageRef}
        >
          <Layer>
            {safeLayers.map((layer, index) => (
              <LayerImage
                key={layer.layerId || index}
                layer={layer}
                width={width}
                height={height}
              />
            ))}
          </Layer>
        </Stage>
      </Box>
    </Box>
  );
}

ShirtViewerPreview.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  title: PropTypes.string,
  stageRef: PropTypes.shape({
    current: PropTypes.instanceOf(Object),
  }),
  layers: PropTypes.arrayOf(
    PropTypes.shape({
      layerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      imageUrl: PropTypes.string,
      x: PropTypes.number,
      y: PropTypes.number,
      opacity: PropTypes.number,
    })
  ),
  zoom: PropTypes.number,
  readOnly: PropTypes.bool,
  hideBorder: PropTypes.bool,
  hideTitle: PropTypes.bool,
  topRightSlot: PropTypes.node,
};

ShirtViewerPreview.defaultProps = {
  title: null,
  stageRef: null,
  layers: [],
  zoom: 1,
  readOnly: false,
  hideBorder: false,
  hideTitle: false,
  topRightSlot: null,
};

export default ShirtViewerPreview;
